<template>
    <div class="form-padding-right">
        <ul>
            <li class="form-label">{{ $t('Survey') }}</li>
            <li>
                <CicSelect
                    id="selectedSurvey"
                    :value="chatAccountDetails.surveyId"
                    :options="surveys.map((survey) => ({ value: survey.surveyId, label: survey.name }))"
                    :enabled="canEdit"
                    :placeholder="$t('None')"
                    clearable
                    @input="(val) => updateFieldValue('surveyId', val.length ? val : null)"
                />
            </li>
            <template v-if="chatAccountDetails.surveyId">
                <li class="form-label">{{ $t('Thank You Message') }}</li>
                <li>
                    <CicTextarea
                        id="thankYouMessage"
                        :value="chatAccountDetails.thankYouMessage"
                        :enabled="canEdit"
                        :autosize="{ minRows: 2 }"
                        input-style="overflow-y: hidden"
                        @input="(val) => updateFieldValue('thankYouMessage', val)"
                    />
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextarea from '@/components/inputs/CicTextarea';

    export default {
        name: 'CSATSurveyOptions',
        components: {
            CicTextarea,
            CicSelect,
        },
        props: {
            chatAccountDetails: {
                type: Object,
                required: true,
            },
            surveys: {
                type: Array,
                required: true,
            },
            canEdit: {
                type: Boolean,
                required: true,
            },
        },
        emits: ['change'],
        methods: {
            updateFieldValue(field, val) {
                this.$emit('change', 'chatAccountDetails', field, val);
            },
        },
    };
</script>
